// extracted by mini-css-extract-plugin
export default {"root":"bookings_page_root__Fm9dx","tableContainer":"bookings_page_tableContainer__L4WTS","bookingsListTable":"bookings_page_bookingsListTable__fbWBs"};